import { onMounted, ref, useAttrs, nextTick, useTemplateRef, watch } from 'vue'
import { http } from '@el-plus/utils/http'
import { componentType } from './uni-vue'
import axios from 'axios'
import { ElMessage, ElLoading } from 'element-plus'

let Vue2: any = null
let VueRouter3: any = null

const loadModules = async () => {
  if (!Vue2) {
    const vue2Module = await import('vue2')
    Vue2 = vue2Module.default
  }
  if (!VueRouter3) {
    const routerModule = await import('vue-router3')
    VueRouter3 = routerModule.default
  }
}

export const useUniVue = (props, _emit) => {
  const uniVue = useTemplateRef<HTMLElement>('uniVue')
  const { type } = props
  const loading = ref(true)
  const isAddress = type === 'address'
  const isBpm = type === 'bpm'
  //   是否需要加载静态资源
  const isLoadStatic = componentType.indexOf(type) > -1
  const attrs = useAttrs()
  const setupWindow = () => {
    Vue2.use(VueRouter3)
    if (!window.Vue) {
      window.Vue = Vue2
    }
    // 地址
    if (isAddress) {
      if (!window.axios) {
        window.axios = axios
      }
      if (!window.ElementUI) {
        window.ElementUI = {
          Message: ElMessage,
          Loading: ElLoading,
        }
      }
    }
  }
  const prepareVueAttributes = () => {
    const events = {}
    const _props = {} as Record<string, any>
    Object.keys(attrs).forEach((key) => {
      if (key.startsWith('on')) {
        let eventName = key.slice(2) // 去掉 'on' 前缀
        if (eventName.startsWith('Update:')) {
          // 处理 v-model:xxx 事件，转换为 update:xxx
          // 例如：onUpdate:modelValue -> update:modelValue、onUpdate:dialogFormData -> update:dialogFormData
          eventName = 'update:' + eventName.slice(7)

          // 如果是v-model, 转换为vue2对应的input
          if (eventName === 'update:modelValue') {
            eventName = 'input'
          }
        } else {
          // 将驼峰命名转换为短横线命名
          // 例如： onInitComplete-> init-complete (因为测试发现用initComplete不生效)
          eventName = eventName.replace(/([A-Z])/g, '-$1').toLowerCase()
          // 删除第一位的-
          eventName = eventName.slice(1)
        }
        events[eventName] = attrs[key]
      } else {
        if (key === 'modelValue') {
          // 处理 v-model转换为vue2的value
          _props.value = attrs[key] // eslint-disable-line
        } else {
          _props[key] = attrs[key]
        }
      }
    })
    return {
      on: events,
      props: _props,
    }
  }

  const cdn = '//j01.hongxinshop.com/'
  const getStaticJsUrl = () => {
    switch (type) {
      case 'bpm':
        return `${cdn}bpm-common/common/index.umd.min.js`
      case 'address':
        return `http://localhost:8001/dist/hx-address.js`
        return `./hx-address.js`
        return `${cdn}address/static/hx-address.js`
      default:
        return ''
    }
  }
  const getStaticCssUrl = () => {
    switch (type) {
      case 'bpm':
        return `/bpm-common/common/index.css`
      case 'address':
        return `/address/static/hx-address.css`
      default:
        return ''
    }
  }
  const loadStaticJsResource = async () => {
    const promises: Promise<void>[] = []

    // 检查并加载element-ui.js（非bpm类型）
    if (!isBpm && !window.ElementUIComponents) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = '/element-ui.js'
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
      })
    }

    // 检查并加载原有的JS资源
    let globalName
    if (isAddress) {
      globalName = 'hxAddress'
    }
    if (isBpm) {
      globalName = 'index'
    }

    if (globalName && !window[globalName]) {
      promises.push(
        new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.src = getStaticJsUrl()
          script.onload = () => resolve()
          script.onerror = reject
          document.body.appendChild(script)
        }),
      )
    }

    return Promise.all(promises)
  }
  const loadStaticCssResource = async () => {
    const cssPromises: Promise<string>[] = []

    // 为非bpm类型加载element-ui.css
    if (!isBpm) {
      cssPromises.push(
        http
          .request<string>('/index.css', {
            responseReturn: 'raw',
            baseURL: '',
          })
          .then((res) => res.data),
      )
    }

    // 加载原有的CSS资源
    const staticCssUrl = getStaticCssUrl()
    if (staticCssUrl) {
      cssPromises.push(
        http
          .request<string>(staticCssUrl, {
            responseReturn: 'raw',
          })
          .then((res) => res.data),
      )
    }

    const cssContents = await Promise.all(cssPromises)
    return cssContents.join('\n')
  }
  let instance
  const setupInstance = async () => {
    if (instance) {
      return
    }
    await loadModules()
    setupWindow()
    const el = uniVue.value
    const shadowRoot = el!.attachShadow({ mode: 'open' })
    const container = document.createElement('div')
    if (isLoadStatic) {
      try {
        loading.value = true
        const [_res1, css] = await Promise.all([
          loadStaticJsResource(),
          loadStaticCssResource(),
        ])
        const style = document.createElement('style')
        style.textContent = css
        shadowRoot.appendChild(style)
        if (isAddress && !document.querySelector('style[data-hx-address-style]')) {
          const headStyle = document.createElement('style')
          headStyle.textContent = css
          headStyle.setAttribute('data-hx-address-style', 'true')
          document.head.appendChild(headStyle)
        }
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }
    shadowRoot.appendChild(container)

    instance = new Vue2({
      el: container,
      router: new VueRouter3(),
      render: (h) => {
        const { on: vue2Events, props: vue2Props } = prepareVueAttributes()
        return h(props.name, {
          props: vue2Props,
          on: vue2Events,
        })
      },
    })
  }

  const updateVue2Instance = () => {
    if (!instance) return
    const child = instance.$children[0]
    if (child) {
      const { props: vue2Props } = prepareVueAttributes()
      Object.assign(child.$options.propsData, vue2Props)
      if (child._props) {
        Object.keys(vue2Props).forEach((key) => {
          const newValue = vue2Props[key]
          const oldValue = child._props[key]
          if (newValue === oldValue && typeof newValue === 'object' && newValue !== null) {
            const temp = {}
            child._props[key] = temp
          }
          child._props[key] = newValue
        })
      }
      child.$forceUpdate()
    }
    instance.$forceUpdate()
  }

  Object.keys(attrs).forEach((key) => {
    if (!key.startsWith('on')) {
      
      watch(
        () => attrs[key],
        () => {
          console.log(key,'key');
          nextTick(() => {
            try {
              updateVue2Instance()
            } catch (e) {
              // 忽略更新异常
            }
          })
        },
        {
          deep: true,
        },
      )
    }
  })

  onMounted(() => {
    setupInstance()
  })

  return {
    loading,
  }
}
